import { useParams } from 'react-router'
import { useGetJobDescriptionById } from '@/hooks/queries/useJobDescriptions'
import { useAuth } from '@/hooks/useAuth'
import { JDDetailView } from '@/components/JDDetailView'

const JDDetailPage = () => {
  const { id } = useParams<{ id: string }>()
  const { data: jobDescription, isLoading, error } = useGetJobDescriptionById(id || '')
  const { user } = useAuth()

  // Check if this is the current user's JD
  const isMyJD = jobDescription?.userId === user?.id

  return (
    <JDDetailView
      jobDescription={jobDescription}
      isLoading={isLoading}
      error={error}
      isMyJD={isMyJD}
      queryKey={['jobDescription', id || '']}
    />
  )
}

export default JDDetailPage
